import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button, Table, Form, Card, Spinner, Modal, Tabs, Tab, Alert, ProgressBar } from 'react-bootstrap';
import Cookies from 'js-cookie';
import api from "../../services/api";
import PdfViewerModal from '../../components/PdfViewerModal';
import DocxViewerModal from '../../components/DocxViewerModal';
import ExcelViewerModal from '../../components/ExcelViewerModal';
import userGenericImage from '../../assets/images/generic_user.png';
import { Link } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { useUpload } from '../../contexts/UploadContext';
import { toast } from 'react-toastify';
import io from 'socket.io-client';
import { useUserAbout } from '../../context/UserAboutContext';

const Index = () => {
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]);
    const fileInputRef = useRef(null);
    const socket = useRef(null);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [pdfName, setPdfName] = useState('');
    const [showDocxModal, setShowDocxModal] = useState(false);
    const [docxUrl, setDocxUrl] = useState(null);
    const [docxName, setDocxName] = useState('');
    const [showExcelModal, setShowExcelModal] = useState(false);
    const [excelUrl, setExcelUrl] = useState(null);
    const [excelName, setExcelName] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [docToDelete, setDocToDelete] = useState(null);
    const [sharedDocuments, setSharedDocuments] = useState([]);
    const [loadingShared, setLoadingShared] = useState(false);
    const [errorShared, setErrorShared] = useState('');
    const [sharedByMeDocuments, setSharedByMeDocuments] = useState([]);
    const [loadingSharedByMe, setLoadingSharedByMe] = useState(false);
    const [errorSharedByMe, setErrorSharedByMe] = useState('');
    const [showShareModal, setShowShareModal] = useState(false);
    const [docToShare, setDocToShare] = useState(null);
    const [friends, setFriends] = useState([]);
    const [groups, setGroups] = useState([]);
    const [selectedFriends, setSelectedFriends] = useState([]);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [loadingShare, setLoadingShare] = useState(false);
    const [errorShare, setErrorShare] = useState('');
    const [searchFriend, setSearchFriend] = useState('');
    const [searchGroup, setSearchGroup] = useState('');
    const [imageErrors, setImageErrors] = useState({});
    const userId = Cookies.get('userId');
    const [activeTab, setActiveTab] = useState('meus');
    const [uploadTotal, setUploadTotal] = useState(0);
    const [uploadLoaded, setUploadLoaded] = useState(0);
    const [fileProgress, setFileProgress] = useState({});
    const { startMultipleUploads } = useUpload();
    const { userAbout, fetchUserAbout } = useUserAbout();

    const token = Cookies.get('token');

    // Adicionar estados para modal de confirmação de remoção de compartilhamento
    const [showRemoveShareModal, setShowRemoveShareModal] = useState(false);
    const [removeShareType, setRemoveShareType] = useState(null); // 'user' ou 'group'
    const [removeShareDocId, setRemoveShareDocId] = useState(null);
    const [removeShareTargetId, setRemoveShareTargetId] = useState(null);
    const [removeShareTargetName, setRemoveShareTargetName] = useState('');

    // Novo estado para modal de remover todos os compartilhamentos
    const [showRemoveAllShareModal, setShowRemoveAllShareModal] = useState(false);
    const [removeAllShareDocId, setRemoveAllShareDocId] = useState(null);
    const [removeAllShareDocName, setRemoveAllShareDocName] = useState('');

    // Adicionar novos estados para as novas modais
    const [showImageModal, setShowImageModal] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);
    const [imageName, setImageName] = useState('');
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null);
    const [videoName, setVideoName] = useState('');

    // Adicionar novo estado para a modal de visualização não disponível
    const [showNoPreviewModal, setShowNoPreviewModal] = useState(false);
    const [noPreviewFileName, setNoPreviewFileName] = useState('');
    const [noPreviewDocId, setNoPreviewDocId] = useState(null);

    // Adicionar novo estado para a modal de edição de compartilhamento
    const [showEditShareModal, setShowEditShareModal] = useState(false);
    const [docToEditShare, setDocToEditShare] = useState(null);
    const [editShareLoading, setEditShareLoading] = useState(false);
    const [editShareError, setEditShareError] = useState('');
    const [editSearchFriend, setEditSearchFriend] = useState('');
    const [editSearchGroup, setEditSearchGroup] = useState('');
    const [editSelectedFriends, setEditSelectedFriends] = useState([]);
    const [editSelectedGroups, setEditSelectedGroups] = useState([]);
    const [editShareableUsers, setEditShareableUsers] = useState([]);
    const [editShareableGroups, setEditShareableGroups] = useState([]);
    const [editSharedUsers, setEditSharedUsers] = useState([]);
    const [editSharedGroups, setEditSharedGroups] = useState([]);
    const [deleteLoading, setDeleteLoading] = useState(false);

    // Estados para pesquisa em cada aba
    const [searchMeusDocs, setSearchMeusDocs] = useState('');
    const [searchCompartilhadosPorMim, setSearchCompartilhadosPorMim] = useState('');
    const [searchCompartilhadosComigo, setSearchCompartilhadosComigo] = useState('');

    // Estados para ordenação
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: 'ascending'
    });

    // Função para ordenar os documentos
    const sortDocuments = (documents, type = 'meus') => {
        if (!sortConfig.key) return documents;

        return [...documents].sort((a, b) => {
            if (sortConfig.key === 'name') {
                const nameA = (a.name || a.filename || '').toLowerCase();
                const nameB = (b.name || b.filename || '').toLowerCase();
                return sortConfig.direction === 'ascending' 
                    ? nameA.localeCompare(nameB)
                    : nameB.localeCompare(nameA);
            }
            if (sortConfig.key === 'created_at') {
                const dateA = new Date(a.created_at || 0);
                const dateB = new Date(b.created_at || 0);
                return sortConfig.direction === 'ascending'
                    ? dateA - dateB
                    : dateB - dateA;
            }
            if (sortConfig.key === 'owner') {
                const nameA = (a.owner?.name || '').toLowerCase();
                const nameB = (b.owner?.name || '').toLowerCase();
                return sortConfig.direction === 'ascending'
                    ? nameA.localeCompare(nameB)
                    : nameB.localeCompare(nameA);
            }
            if (sortConfig.key === 'shared_with') {
                const usersA = (a.shared_users || []).length;
                const groupsA = (a.shared_groups || []).length;
                const totalA = usersA + groupsA;
                
                const usersB = (b.shared_users || []).length;
                const groupsB = (b.shared_groups || []).length;
                const totalB = usersB + groupsB;
                
                return sortConfig.direction === 'ascending'
                    ? totalA - totalB
                    : totalB - totalA;
            }
            return 0;
        });
    };

    // Função para solicitar ordenação
    const requestSort = (key, type = 'meus') => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Listar documentos
    const fetchDocuments = async () => {
        setLoading(true);
        setError('');
        try {
            const response = await api.get('/api/documents', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.data || !response.data.documents) throw new Error('Nenhum documento encontrado');
            setDocuments(response.data.documents || []);
        } catch (err) {
            setError('Erro ao buscar documentos');
        } finally {
            setLoading(false);
        }
    };

    // Efeito para escutar o evento de atualização da tabela
    useEffect(() => {
        const handleRefreshDocuments = () => {
            fetchDocuments();
        };

        window.addEventListener('refreshDocuments', handleRefreshDocuments);

        return () => {
            window.removeEventListener('refreshDocuments', handleRefreshDocuments);
        };
    }, []);

    const fetchSharedDocuments = async () => {
        setLoadingShared(true);
        setErrorShared('');
        try {
            const response = await api.get('/api/documents/shared/with-me', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.data || !response.data.documents) throw new Error('Erro ao buscar documentos compartilhados');
            setSharedDocuments(response.data.documents || []);
        } catch (err) {
            setErrorShared('Erro ao buscar documentos compartilhados');
        } finally {
            setLoadingShared(false);
        }
    };

    const fetchSharedByMeDocuments = async () => {
        setLoadingSharedByMe(true);
        setErrorSharedByMe('');
        try {
            const response = await api.get('/api/documents/shared/by-me', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (!response.data || !response.data.documents) throw new Error('Erro ao buscar documentos compartilhados');
            setSharedByMeDocuments(response.data.documents || []);
        } catch (err) {
            setErrorSharedByMe('Erro ao buscar documentos compartilhados');
        } finally {
            setLoadingSharedByMe(false);
        }
    };

    useEffect(() => {
        fetchDocuments();
        fetchSharedDocuments();
        fetchSharedByMeDocuments();

        // Configurar socket
        socket.current = io(process.env.REACT_APP_API_SOCKET_URL, {
            autoConnect: true,
            withCredentials: true,
            auth: {
                token: Cookies.get('token')
            }
        });

        // Listener para quando o documento é compartilhado
        socket.current.on('document-shared', (data) => {
            console.log('Documento compartilhado:', data);
            toast.success(`${data.shared_by.name} compartilhou um documento com você`, {
                autoClose: 3000
            });
            // Atualizar a lista de documentos compartilhados
            fetchSharedDocuments();
        });

        // Cleanup do socket quando o componente for desmontado
        return () => {
            if (socket.current) {
                socket.current.off('document-shared');
                socket.current.disconnect();
            }
        };
    }, []);

    // Upload de arquivo
    const handleFileChange = (event) => {
        const files = event.target.files;
        setSelectedFiles(Array.from(files));
        setError('');
    };

    const handleUpload = () => {
        if (selectedFiles.length === 0) return;
        setError('');
        startMultipleUploads(selectedFiles);
        setSelectedFiles([]); // Limpa os arquivos selecionados após iniciar upload
        if (fileInputRef.current) fileInputRef.current.value = '';
        // Não chama fetchDocuments aqui, pois o polling global do contexto cuida disso
    };

    // Visualizar documento
    const handleView = async (id, name) => {
        const lowerName = name ? name.toLowerCase() : '';
        const isPdf = lowerName.endsWith('.pdf');
        const isDocx = lowerName.endsWith('.docx') || lowerName.endsWith('.doc');
        const isExcel = lowerName.endsWith('.xls') || lowerName.endsWith('.xlsx');
        const isImage = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(lowerName);
        const isVideo = /\.(mp4|webm|ogg|mov)$/i.test(lowerName);

        try {
            // Agora o backend retorna { url: '...' }
            const response = await api.get(`/api/documents/${id}/view`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const fileUrl = response.data.url;

            if (isPdf) {
                setPdfUrl(fileUrl);
                setPdfName(name);
                setShowPdfModal(true);
            } else if (isDocx) {
                setDocxUrl(fileUrl);
                setDocxName(name);
                setShowDocxModal(true);
            } else if (isExcel) {
                setExcelUrl(fileUrl);
                setExcelName(name);
                setShowExcelModal(true);
            } else if (isImage) {
                setImageUrl(fileUrl);
                setImageName(name);
                setShowImageModal(true);
            } else if (isVideo) {
                setVideoUrl(fileUrl);
                setVideoName(name);
                setShowVideoModal(true);
            } else {
                setNoPreviewFileName(name);
                setNoPreviewDocId(id);
                setShowNoPreviewModal(true);
            }
        } catch (err) {
            setError('Erro ao visualizar arquivo');
        }
    };

    // Download do documento
    const handleDownload = async (id, name) => {
        try {
            // Agora o backend retorna { url: '...' }
            const response = await api.get(`/api/documents/${id}/download`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const fileUrl = response.data.url;

            // Baixa o arquivo como blob para garantir o nome original
            const fileResponse = await fetch(fileUrl);
            const blob = await fileResponse.blob();

            // Cria um link temporário e força o download com o nome original
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', name || 'arquivo');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
        } catch (err) {
            setError('Erro ao fazer download do documento');
        }
    };

    // Excluir documento
    const handleDelete = async (id) => {
        setError('');
        setDeleteLoading(true);
        try {
            const response = await api.delete(`/api/documents/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (response.status !== 200 && response.status !== 204) throw new Error('Erro ao excluir documento');
            fetchDocuments();
        } catch (err) {
            setError('Erro ao excluir documento');
        }
        setShowDeleteModal(false);
        setDocToDelete(null);
        setDeleteLoading(false);
    };

    // Limpa a URL do blob ao fechar o modal
    useEffect(() => {
        if (!showPdfModal && pdfUrl) {
            window.URL.revokeObjectURL(pdfUrl);
            setPdfUrl(null);
        }
        if (!showDocxModal && docxUrl) {
            window.URL.revokeObjectURL(docxUrl);
            setDocxUrl(null);
        }
        if (!showExcelModal && excelUrl) {
            window.URL.revokeObjectURL(excelUrl);
            setExcelUrl(null);
        }
        if (!showImageModal && imageUrl) {
            window.URL.revokeObjectURL(imageUrl);
            setImageUrl(null);
        }
        if (!showVideoModal && videoUrl) {
            window.URL.revokeObjectURL(videoUrl);
            setVideoUrl(null);
        }
        // eslint-disable-next-line
    }, [showPdfModal, showDocxModal, showExcelModal, showImageModal, showVideoModal]);

    const openShareModal = async (docId) => {
        setDocToShare(docId);
        setShowShareModal(true);
        setLoadingShare(true);
        setErrorShare('');
        try {
            // Buscar amigos
            const friendsRes = await api.post('/api/friendsPaginated/show', {
                loged_user: userId,
                token,
                search: '',
                page: 1,
                limit: 1000 // busca todos
            });
            setFriends(friendsRes.data.data || []);
            // Buscar grupos (agora igual ao sidebar)
            const groupsRes = await api.get(`/api/user/groups/${userId}`);
            setGroups(groupsRes.data.groups || []);
        } catch (err) {
            setErrorShare('Erro ao buscar amigos ou grupos');
        } finally {
            setLoadingShare(false);
        }
    };

    const handleShare = async () => {
        setLoadingShare(true);
        setErrorShare('');
        try {
            // Compartilhar com amigos (usuários)
            if (selectedFriends.length > 0) {
                await api.post(`/api/documents/${docToShare}/share/users`, {
                    user_ids: selectedFriends
                }, { 
                    headers: { 'Authorization': `Bearer ${token}` } 
                });
            }

            // Compartilhar com grupos
            if (selectedGroups.length > 0) {
                await api.post(`/api/documents/${docToShare}/share/groups`, {
                    group_ids: selectedGroups
                }, { 
                    headers: { 'Authorization': `Bearer ${token}` } 
                });
            }

            // Emitir evento de compartilhamento para cada usuário/grupo
            const docToShareData = documents.find(doc => doc.id === docToShare);
            if (docToShareData && socket.current) {
                // Emitir para usuários
                selectedFriends.forEach(userId => {
                    socket.current.emit('document-shared', {
                        document_id: docToShare,
                        document_name: docToShareData.name || docToShareData.filename,
                        shared_by: {
                            id: userId,
                            name: userAbout?.user?.name || 'Usuário'
                        },
                        shared_with: {
                            type: 'user',
                            id: userId
                        }
                    });
                });

                // Emitir para grupos
                selectedGroups.forEach(groupId => {
                    socket.current.emit('document-shared', {
                        document_id: docToShare,
                        document_name: docToShareData.name || docToShareData.filename,
                        shared_by: {
                            id: userId,
                            name: userAbout?.user?.name || 'Usuário'
                        },
                        shared_with: {
                            type: 'group',
                            id: groupId
                        }
                    });
                });
            }

            // Mostrar toast de sucesso
            toast.success('Documento compartilhado com sucesso!', {
                autoClose: 3000
            });

            setShowShareModal(false);
            setSelectedFriends([]);
            setSelectedGroups([]);
            
            // Atualizar a lista de documentos compartilhados
            fetchSharedByMeDocuments();
        } catch (err) {
            setErrorShare('Erro ao compartilhar documento');
            toast.error('Erro ao compartilhar documento', {
                autoClose: 3000
            });
        } finally {
            setLoadingShare(false);
        }
    };

    // Funções para remover compartilhamento com usuário e grupo
    const handleRemoveShareUser = async (docId, userId) => {
        try {
            await api.delete(`/api/documents/${docId}/share/users/${userId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            fetchSharedByMeDocuments();
        } catch (err) {
            alert('Erro ao remover compartilhamento com o usuário.');
        }
    };

    const handleRemoveShareGroup = async (docId, groupId) => {
        try {
            await api.delete(`/api/documents/${docId}/share/groups/${groupId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            fetchSharedByMeDocuments();
        } catch (err) {
            alert('Erro ao remover compartilhamento com o grupo.');
        }
    };

    // Função utilitária para obter imagem válida do proprietário (usuário)
    const getOwnerImage = (owner) => {
        if (!owner) return '/assets/images/user/default-avatar.png';
        // Se for grupo (mantém compatibilidade futura)
        if (owner.type === 'group' || owner.is_group) {
            if (owner.photo && owner.photo !== '') return owner.photo;
            return userGenericImage;
        }
        // Se for usuário
        let img = owner.user_about?.image_profile || owner.image_profile;
        if (img && img.trim() !== '') {
            // Se não começar com http ou /, concatene o caminho base
            if (!/^https?:\/\//.test(img) && !img.startsWith('/')) {
                img = `/uploads/usuarios/${img}`;
            }
            return img;
        }
        return '/assets/images/user/default-avatar.png';
    };

    const style = document.createElement('style');
    style.innerHTML = `
      .selectable-item:hover {
        background: #232323 !important;
        border-color: #232323 !important;
        transition: background 0.2s, border 0.2s;
      }
    `;
    document.head.appendChild(style);

    // Funções para abrir modal de confirmação
    const openRemoveShareModal = (type, docId, targetId, targetName) => {
        setRemoveShareType(type);
        setRemoveShareDocId(docId);
        setRemoveShareTargetId(targetId);
        setRemoveShareTargetName(targetName);
        setShowRemoveShareModal(true);
    };

    // Função para confirmar remoção
    const confirmRemoveShare = () => {
        if (removeShareType === 'user') {
            handleRemoveShareUser(removeShareDocId, removeShareTargetId);
        } else if (removeShareType === 'group') {
            handleRemoveShareGroup(removeShareDocId, removeShareTargetId);
        }
        setShowRemoveShareModal(false);
        setRemoveShareType(null);
        setRemoveShareDocId(null);
        setRemoveShareTargetId(null);
        setRemoveShareTargetName('');
    };

    // Função para abrir modal de remover todos
    const openRemoveAllShareModal = (docId, docName) => {
        setRemoveAllShareDocId(docId);
        setRemoveAllShareDocName(docName);
        setShowRemoveAllShareModal(true);
    };

    // Função para remover todos os compartilhamentos
    const handleRemoveAllShares = async () => {
        const doc = sharedByMeDocuments.find(d => d.id === removeAllShareDocId);
        if (!doc) return;
        // Remover todos os usuários
        if (doc.shared_users && doc.shared_users.length > 0) {
            for (const user of doc.shared_users) {
                await handleRemoveShareUser(doc.id, user.id);
            }
        }
        // Remover todos os grupos
        if (doc.shared_groups && doc.shared_groups.length > 0) {
            for (const group of doc.shared_groups) {
                await handleRemoveShareGroup(doc.id, group.id);
            }
        }
        setShowRemoveAllShareModal(false);
        setRemoveAllShareDocId(null);
        setRemoveAllShareDocName('');
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        if (tab === 'compartilhados-por-mim') {
            fetchSharedByMeDocuments();
        } else if (tab === 'compartilhados') {
            fetchSharedDocuments();
        }
    };

    const openEditShareModal = async (docId) => {
        setDocToEditShare(docId);
        setShowEditShareModal(true);
        setEditShareLoading(true);
        setEditShareError('');
        setEditSearchFriend('');
        setEditSearchGroup('');
        setEditSelectedFriends([]);
        setEditSelectedGroups([]);
        setEditSharedUsers([]);
        setEditSharedGroups([]);

        try {
            // Buscar dados de compartilhamento
            const response = await api.get(`/api/documents/${docId}/shareable`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            // Ajuste para os nomes corretos do backend
            const { available_users, available_groups, shared_users, shared_groups } = response.data;

            setEditShareableUsers(available_users || []);
            setEditShareableGroups(available_groups || []);
            setEditSelectedFriends(shared_users.map(user => user.id));
            setEditSelectedGroups(shared_groups.map(group => group.id));
            setEditSharedUsers(shared_users || []);
            setEditSharedGroups(shared_groups || []);
        } catch (err) {
            setEditShareError('Erro ao carregar dados de compartilhamento');
        } finally {
            setEditShareLoading(false);
        }
    };

    const handleRemoveSharedUser = (userId) => {
        setEditSelectedFriends(editSelectedFriends.filter(id => id !== userId));
    };

    const handleRemoveSharedGroup = (groupId) => {
        setEditSelectedGroups(editSelectedGroups.filter(id => id !== groupId));
    };

    const handleEditShare = async () => {
        setEditShareLoading(true);
        setEditShareError('');
        try {
            await api.put(`/api/documents/${docToEditShare}/shares`, {
                user_ids: editSelectedFriends,
                group_ids: editSelectedGroups
            }, { headers: { 'Authorization': `Bearer ${token}` } });

            setShowEditShareModal(false);
            fetchSharedByMeDocuments();
        } catch (err) {
            setEditShareError('Erro ao atualizar compartilhamentos');
        } finally {
            setEditShareLoading(false);
        }
    };

    return (
        <div id="content-page" className="content-inner">
            <Container>
                <Row>
                    <Col sm="12">
                        <Card className='position-relative inner-page-bg bg-primary p-5'>
                            <div className='inner-page-title' style={{ display: 'flex', justifyContent: 'space-between', width: '-webkit-fill-available' }}>
                                <h3 className='text-white'>Drive</h3>
                            </div>
                        </Card>
                    </Col>
                    <Col sm="12" lg="12">
                        <Card>
                            <Card.Body>
                                <Form className='row'>
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <div className="input-group">
                                            <Form.Control
                                                type="file"
                                                multiple={true}
                                                accept="*/*"
                                                onChange={handleFileChange}
                                                disabled={uploading}
                                                ref={fileInputRef}
                                            />
                                            <Button variant="primary" onClick={handleUpload} disabled={!selectedFiles || uploading} className="ms-2">
                                                {uploading ? <Spinner animation="border" size="sm" className="me-2" /> : null}
                                                {uploading ? 'Enviando...' : 'Enviar'}
                                            </Button>
                                        </div>
                                    </Form.Group>
                                </Form>
                                {error && <div className="alert alert-danger mt-3">{error}</div>}
                                <hr />
                                <Tabs defaultActiveKey="meus" id="document-tabs" className="mb-3" onSelect={handleTabChange}>
                                    <Tab eventKey="meus" title="Meus documentos">
                                        {loading ? (
                                            <div className="d-flex justify-content-center w-100 py-4">
                                                <Spinner animation="border" />
                                            </div>
                                        ) : (
                                            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                                <Form.Group className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Pesquisar documentos..."
                                                        value={searchMeusDocs}
                                                        onChange={(e) => setSearchMeusDocs(e.target.value)}
                                                    />
                                                </Form.Group>
                                                <Table striped bordered hover responsive>
                                                    <thead>
                                                        <tr>
                                                            <th 
                                                                onClick={() => requestSort('name')}
                                                                style={{ cursor: 'pointer' }}
                                                                className="d-flex align-items-center"
                                                            >
                                                                Nome
                                                                {sortConfig.key === 'name' && (
                                                                    <span className="material-symbols-outlined ms-1" style={{ fontSize: 18 }}>
                                                                        {sortConfig.direction === 'ascending' ? 'arrow_upward' : 'arrow_downward'}
                                                                    </span>
                                                                )}
                                                            </th>
                                                            <th 
                                                                className='text-center'
                                                                onClick={() => requestSort('created_at')}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <span className="d-flex align-items-center justify-content-center">
                                                                    Salvo em
                                                                    {sortConfig.key === 'created_at' && (
                                                                        <span className="material-symbols-outlined ms-1" style={{ fontSize: 18 }}>
                                                                            {sortConfig.direction === 'ascending' ? 'arrow_upward' : 'arrow_downward'}
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            </th>
                                                            <th className='text-center'>Ações</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {documents.length === 0 ? (
                                                            <tr><td colSpan="3">Nenhum documento encontrado.</td></tr>
                                                        ) : (
                                                            sortDocuments(documents
                                                                .filter(doc => 
                                                                    doc.name?.toLowerCase().includes(searchMeusDocs.toLowerCase()) ||
                                                                    doc.filename?.toLowerCase().includes(searchMeusDocs.toLowerCase())
                                                                ))
                                                                .map((doc) => {
                                                                    return (
                                                                        <tr key={doc.id}>
                                                                            <td className='align-middle'>
                                                                                <span className="d-flex align-items-center">
                                                                                    <span className="material-symbols-outlined md-20 me-1 fs-5">description</span>
                                                                                    {doc.name || doc.filename || 'Documento'}
                                                                                </span>
                                                                            </td>
                                                                            <td className='align-middle text-center'>
                                                                                {doc.created_at ? (
                                                                                    (() => {
                                                                                        const date = new Date(doc.created_at);
                                                                                        const dataFormatada = date.toLocaleDateString('pt-BR', {
                                                                                            day: '2-digit',
                                                                                            month: 'long',
                                                                                            year: 'numeric'
                                                                                        });
                                                                                        const hours = date.getHours().toString().padStart(2, '0');
                                                                                        const minutes = date.getMinutes().toString().padStart(2, '0');
                                                                                        return `${dataFormatada} - ${hours}h${minutes}`;
                                                                                    })()
                                                                                ) : '-'}
                                                                            </td>
                                                                            <td className='align-middle text-center'>
                                                                                <div className="d-flex align-items-center justify-content-center gap-3">
                                                                                    <Button
                                                                                        variant="link"  // Remove o estilo padrão do botão
                                                                                        size="lg"
                                                                                        className="d-flex align-items-center p-0 border-0 bg-transparent"  // Remove o padding, borda e fundo
                                                                                        onClick={() => {
                                                                                            openShareModal(doc.id);
                                                                                        }}
                                                                                    >
                                                                                        <span className="material-symbols-outlined me-1" style={{ fontSize: 20 }}>share</span>
                                                                                    </Button>
                                                                                    <Button
                                                                                        variant="link"  // Remove o estilo padrão do botão
                                                                                        size="lg"
                                                                                        className="d-flex align-items-center p-0 border-0 bg-transparent"  // Remove o padding, borda e fundo
                                                                                        onClick={() => handleView(doc.id, doc.name)}
                                                                                    >
                                                                                        <span className="material-symbols-outlined me-1" style={{ fontSize: 20 }}>visibility</span>
                                                                                    </Button>

                                                                                    <Button
                                                                                        variant="link"  // Remove o estilo padrão do botão
                                                                                        size="lg"
                                                                                        className="d-flex align-items-center p-0 border-0 bg-transparent"  // Remove o padding, borda e fundo
                                                                                        onClick={() => handleDownload(doc.id, doc.name)}
                                                                                    >
                                                                                        <span className="material-symbols-outlined me-1" style={{ fontSize: 20 }}>download</span>
                                                                                    </Button>
                                                                                    <Button
                                                                                        variant="link"
                                                                                        size="lg"
                                                                                        className="d-flex align-items-center p-0 border-0 bg-transparent"  // Remove o padding, borda e fundo
                                                                                        onClick={() => { setShowDeleteModal(true); setDocToDelete(doc.id); }}
                                                                                    >
                                                                                        <span className="material-symbols-outlined me-1" style={{ fontSize: 20 }}>delete</span>
                                                                                    </Button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        )}
                                    </Tab>
                                    <Tab eventKey="compartilhados-por-mim" title="Meus documentos compartilhados">
                                        {loadingSharedByMe ? (
                                            <div className="d-flex justify-content-center w-100 py-4">
                                                <Spinner animation="border" />
                                            </div>
                                        ) : (
                                            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                                <Form.Group className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Pesquisar documentos..."
                                                        value={searchCompartilhadosPorMim}
                                                        onChange={(e) => setSearchCompartilhadosPorMim(e.target.value)}
                                                    />
                                                </Form.Group>
                                                <Table striped bordered hover responsive>
                                                    <thead style={{ position: 'sticky', top: 0, backgroundColor: '#1a1a1a', zIndex: 1 }}>
                                                        <tr>
                                                            <th 
                                                                onClick={() => requestSort('name', 'compartilhados-por-mim')}
                                                                style={{ cursor: 'pointer' }}
                                                                className="d-flex align-items-center"
                                                            >
                                                                Nome
                                                                {sortConfig.key === 'name' && (
                                                                    <span className="material-symbols-outlined ms-1" style={{ fontSize: 18 }}>
                                                                        {sortConfig.direction === 'ascending' ? 'arrow_upward' : 'arrow_downward'}
                                                                    </span>
                                                                )}
                                                            </th>
                                                            <th 
                                                                className='text-center'
                                                                onClick={() => requestSort('shared_with', 'compartilhados-por-mim')}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <span className="d-flex align-items-center justify-content-center">
                                                                    Compartilhados com Usuários/Grupos
                                                                    {sortConfig.key === 'shared_with' && (
                                                                        <span className="material-symbols-outlined ms-1" style={{ fontSize: 18 }}>
                                                                            {sortConfig.direction === 'ascending' ? 'arrow_upward' : 'arrow_downward'}
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            </th>
                                                            <th className='text-center'>Ações</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {sharedByMeDocuments.length === 0 ? (
                                                            <tr><td colSpan="3">Nenhum documento compartilhado por você.</td></tr>
                                                        ) : (
                                                            sortDocuments(sharedByMeDocuments
                                                                .filter(doc => 
                                                                    doc.name?.toLowerCase().includes(searchCompartilhadosPorMim.toLowerCase()) ||
                                                                    doc.filename?.toLowerCase().includes(searchCompartilhadosPorMim.toLowerCase())
                                                                ), 'compartilhados-por-mim')
                                                                .map((doc) => {
                                                                    return (
                                                                        <tr key={doc.id}>
                                                                            <td className='align-middle'>
                                                                                <span className="d-flex align-items-center">
                                                                                    <span className="material-symbols-outlined md-20 me-1 fs-5">description</span>
                                                                                    {doc.name || doc.filename || 'Documento'}
                                                                                </span>
                                                                            </td>
                                                                            <td className='align-middle'>
                                                                                <div className="d-flex align-items- justify-content-center">
                                                                                    {/* Ícone e imagens dos usuários compartilhados */}
                                                                                    {doc.shared_users && doc.shared_users.length > 0 && (
                                                                                        <OverlayTrigger
                                                                                            trigger="click"
                                                                                            placement="bottom"
                                                                                            rootClose
                                                                                            overlay={
                                                                                                <Popover id={`popover-users-${doc.id}`}>
                                                                                                    <Popover.Header as="h3">Usuários compartilhados</Popover.Header>
                                                                                                    <Popover.Body>
                                                                                                        <ul
                                                                                                            style={{
                                                                                                                listStyle: 'none',
                                                                                                                padding: 0,
                                                                                                                margin: 0,
                                                                                                                maxHeight: doc.shared_users.length > 15 ? 350 : 'auto',
                                                                                                                overflowY: doc.shared_users.length > 15 ? 'auto' : 'visible'
                                                                                                            }}
                                                                                                        >
                                                                                                            {doc.shared_users.map((user) => (
                                                                                                                <li key={`user-popover-${user.id}`} className="d-flex align-items-center mb-2">
                                                                                                                    <div style={{ width: 20, height: 20, borderRadius: '50%', overflow: 'hidden', backgroundColor: '#f0f0f0', marginRight: 8 }}>
                                                                                                                        <img
                                                                                                                            className="profile-img"
                                                                                                                            src={
                                                                                                                                user.user_about?.image_profile && user.user_about.image_profile.trim() !== ''
                                                                                                                                    ? user.user_about.image_profile
                                                                                                                                    : '/assets/images/user/default-avatar.png'
                                                                                                                            }
                                                                                                                            alt={user.name}
                                                                                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                                                                            onError={e => { e.target.onerror = null; e.target.src = '/assets/images/user/default-avatar.png'; }}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                    <Link to={`/users/profile/${user.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                                                                                        {user.name.length > 12 ? user.name.slice(0, 12) + '...' : user.name}
                                                                                                                    </Link>
                                                                                                                </li>
                                                                                                            ))}
                                                                                                        </ul>
                                                                                                    </Popover.Body>
                                                                                                </Popover>
                                                                                            }
                                                                                        >
                                                                                            <div
                                                                                                className="bg-primary"
                                                                                                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', borderRadius: 20, padding: '4px 4px', marginRight: doc.shared_groups && doc.shared_groups.length > 0 ? 12 : 0 }}
                                                                                            >
                                                                                                <span className="material-symbols-outlined me-1" style={{ fontSize: 18 }}>person</span>
                                                                                                <div className="d-flex align-items-center" style={{ position: 'relative', width: doc.shared_users.length > 0 ? `${24 + (doc.shared_users.length - 1) * 16}px` : '0px' }}>
                                                                                                    {doc.shared_users.map((user, idx) => (
                                                                                                        <div
                                                                                                            key={`user-img-${user.id}`}
                                                                                                            style={{
                                                                                                                width: 24,
                                                                                                                height: 24,
                                                                                                                borderRadius: '50%',
                                                                                                                overflow: 'hidden',
                                                                                                                backgroundColor: '#f0f0f0',
                                                                                                                border: '1.5px solid #fff',
                                                                                                                position: 'absolute',
                                                                                                                left: `${idx * 16}px`,
                                                                                                                zIndex: 10 + idx
                                                                                                            }}
                                                                                                        >
                                                                                                            <img
                                                                                                                className="profile-img"
                                                                                                                src={
                                                                                                                    user.user_about?.image_profile && user.user_about.image_profile.trim() !== ''
                                                                                                                        ? user.user_about.image_profile
                                                                                                                        : '/assets/images/user/default-avatar.png'
                                                                                                                }
                                                                                                                alt={user.name}
                                                                                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                                                                onError={e => { e.target.onerror = null; e.target.src = '/assets/images/user/default-avatar.png'; }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    ))}
                                                                                                </div>
                                                                                            </div>
                                                                                        </OverlayTrigger>
                                                                                    )}
                                                                                    {/* Ícone e imagens dos grupos compartilhados */}
                                                                                    {doc.shared_groups && doc.shared_groups.length > 0 && (
                                                                                        <OverlayTrigger
                                                                                            trigger="click"
                                                                                            placement="bottom"
                                                                                            rootClose
                                                                                            overlay={
                                                                                                <Popover id={`popover-groups-${doc.id}`}>
                                                                                                    <Popover.Header as="h3">Grupos compartilhados</Popover.Header>
                                                                                                    <Popover.Body>
                                                                                                        <ul
                                                                                                            style={{
                                                                                                                listStyle: 'none',
                                                                                                                padding: 0,
                                                                                                                margin: 0,
                                                                                                                maxHeight: doc.shared_groups.length > 15 ? 350 : 'auto',
                                                                                                                overflowY: doc.shared_groups.length > 15 ? 'auto' : 'visible'
                                                                                                            }}
                                                                                                        >
                                                                                                            {doc.shared_groups.map((group) => (
                                                                                                                <li key={`group-popover-${group.id}`} className="d-flex align-items-center mb-2">
                                                                                                                    <div style={{ width: 20, height: 20, borderRadius: '50%', overflow: 'hidden', backgroundColor: '#f0f0f0', marginRight: 8 }}>
                                                                                                                        <img
                                                                                                                            className="profile-img"
                                                                                                                            src={
                                                                                                                                group.photo && group.photo.trim() !== ''
                                                                                                                                    ? group.photo
                                                                                                                                    : userGenericImage
                                                                                                                            }
                                                                                                                            alt={group.name}
                                                                                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                                                                            onError={e => { e.target.onerror = null; e.target.src = userGenericImage; }}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                    <Link to={`/groups/group-detail/${group.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                                                                                        {group.name.length > 12 ? group.name.slice(0, 12) + '...' : group.name}
                                                                                                                    </Link>
                                                                                                                </li>
                                                                                                            ))}
                                                                                                        </ul>
                                                                                                    </Popover.Body>
                                                                                                </Popover>
                                                                                            }
                                                                                        >
                                                                                            <div
                                                                                                className="bg-primary"
                                                                                                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', borderRadius: 20, padding: '4px 4px' }}
                                                                                            >
                                                                                                <span className="material-symbols-outlined me-1" style={{ fontSize: 18 }}>groups</span>
                                                                                                <div className="d-flex align-items-center" style={{ position: 'relative', width: doc.shared_groups.length > 0 ? `${24 + (doc.shared_groups.length - 1) * 16}px` : '0px' }}>
                                                                                                    {doc.shared_groups.map((group, idx) => (
                                                                                                        <div
                                                                                                            key={`group-img-${group.id}`}
                                                                                                            style={{
                                                                                                                width: 24,
                                                                                                                height: 24,
                                                                                                                borderRadius: '50%',
                                                                                                                overflow: 'hidden',
                                                                                                                backgroundColor: '#f0f0f0',
                                                                                                                border: '2px solid #fff',
                                                                                                                position: 'absolute',
                                                                                                                left: `${idx * 16}px`,
                                                                                                                zIndex: 10 + idx
                                                                                                            }}
                                                                                                        >
                                                                                                            <img
                                                                                                                className="profile-img"
                                                                                                                src={
                                                                                                                    group.photo && group.photo.trim() !== ''
                                                                                                                        ? group.photo
                                                                                                                        : userGenericImage
                                                                                                                }
                                                                                                                alt={group.name}
                                                                                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                                                                onError={e => { e.target.onerror = null; e.target.src = userGenericImage; }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    ))}
                                                                                                </div>
                                                                                            </div>
                                                                                        </OverlayTrigger>
                                                                                    )}
                                                                                    {/* Caso não tenha nenhum compartilhamento */}
                                                                                    {(!doc.shared_users || doc.shared_users.length === 0) && (!doc.shared_groups || doc.shared_groups.length === 0) && (
                                                                                        <span className="text-muted">Nenhum</span>
                                                                                    )}
                                                                                </div>
                                                                            </td>
                                                                            <td className='align-middle text-center'>
                                                                                <div className="d-flex align-items-center flex-wrap gap-2 justify-content-center">
                                                                                    <Button
                                                                                        variant="link"
                                                                                        size="lg"
                                                                                        className="d-flex align-items-center p-0 border-0 bg-transparent"
                                                                                        onClick={() => openEditShareModal(doc.id)}
                                                                                        title="Editar compartilhamentos"
                                                                                        style={{ padding: '2px 4px', lineHeight: 1 }}
                                                                                    >
                                                                                        <span className="material-symbols-outlined" style={{ fontSize: 20 }}>edit</span>
                                                                                    </Button>
                                                                                    <Button
                                                                                        variant="link"
                                                                                        size="lg"
                                                                                        className="d-flex align-items-center p-0 border-0 bg-transparent"
                                                                                        onClick={() => openRemoveAllShareModal(doc.id, doc.name || doc.filename || 'Documento')}
                                                                                        title="Remover todos os compartilhamentos deste documento"
                                                                                        style={{ padding: '2px 4px', lineHeight: 1 }}
                                                                                    >
                                                                                        <span className="material-symbols-outlined" style={{ fontSize: 20 }}>delete</span>
                                                                                    </Button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        )}
                                        {errorSharedByMe && <div className="alert alert-danger mt-3">{errorSharedByMe}</div>}
                                    </Tab>
                                    <Tab eventKey="compartilhados" title="Compartilhados comigo">
                                        {loadingShared ? (
                                            <div className="d-flex justify-content-center w-100 py-4">
                                                <Spinner animation="border" />
                                            </div>
                                        ) : (
                                            <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                                <Form.Group className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Pesquisar documentos..."
                                                        value={searchCompartilhadosComigo}
                                                        onChange={(e) => setSearchCompartilhadosComigo(e.target.value)}
                                                    />
                                                </Form.Group>
                                                <Table striped bordered hover responsive>
                                                    <thead style={{ position: 'sticky', top: 0, backgroundColor: '#1a1a1a', zIndex: 1 }}>
                                                        <tr>
                                                            <th 
                                                                onClick={() => requestSort('name', 'compartilhados')}
                                                                style={{ cursor: 'pointer' }}
                                                                className="d-flex align-items-center"
                                                            >
                                                                Nome
                                                                {sortConfig.key === 'name' && (
                                                                    <span className="material-symbols-outlined ms-1" style={{ fontSize: 18 }}>
                                                                        {sortConfig.direction === 'ascending' ? 'arrow_upward' : 'arrow_downward'}
                                                                    </span>
                                                                )}
                                                            </th>
                                                            <th 
                                                                className='text-center'
                                                                onClick={() => requestSort('owner', 'compartilhados')}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <span className="d-flex align-items-center justify-content-center">
                                                                    Proprietário
                                                                    {sortConfig.key === 'owner' && (
                                                                        <span className="material-symbols-outlined ms-1" style={{ fontSize: 18 }}>
                                                                            {sortConfig.direction === 'ascending' ? 'arrow_upward' : 'arrow_downward'}
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            </th>
                                                            <th className='text-center'>Ações</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {sharedDocuments.length === 0 ? (
                                                            <tr><td colSpan="3">Nenhum documento compartilhado.</td></tr>
                                                        ) : (
                                                            sortDocuments(sharedDocuments
                                                                .filter(doc => 
                                                                    doc.name?.toLowerCase().includes(searchCompartilhadosComigo.toLowerCase()) ||
                                                                    doc.filename?.toLowerCase().includes(searchCompartilhadosComigo.toLowerCase())
                                                                ), 'compartilhados')
                                                                .map((doc) => {
                                                                    return (
                                                                        <tr key={doc.id}>
                                                                            <td className='align-middle'>
                                                                                <span className="d-flex align-items-center">
                                                                                    <span className="material-symbols-outlined md-20 me-1 fs-5">description</span>
                                                                                    {doc.name || doc.filename || 'Documento'}
                                                                                </span>
                                                                            </td>
                                                                            <td className='align-middle text-center'>
                                                                                <Link to={`/users/profile/${doc.owner?.id}`} style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                    <div className="me-2" style={{ width: '20px', height: '20px', borderRadius: '50%', overflow: 'hidden', backgroundColor: '#f0f0f0' }}>
                                                                                        <img
                                                                                            className="profile-img"
                                                                                            src={
                                                                                                imageErrors[`owner-${doc.owner?.id}`]
                                                                                                    ? '/assets/images/user/default-avatar.png'
                                                                                                    : getOwnerImage(doc.owner)
                                                                                            }
                                                                                            alt={doc.owner?.name || 'Proprietário'}
                                                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                                            onError={() => {
                                                                                                setImageErrors(prev => ({
                                                                                                    ...prev,
                                                                                                    [`owner-${doc.owner?.id}`]: true
                                                                                                }));
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                    {doc.owner?.name
                                                                                        ? doc.owner.name.length > 12
                                                                                            ? doc.owner.name.slice(0, 12) + '...'
                                                                                            : doc.owner.name
                                                                                        : '-'}
                                                                                </Link>
                                                                            </td>
                                                                            <td className='align-middle text-center'>
                                                                                <div className="d-flex align-items-center justify-content-center gap-3">
                                                                                    <Button
                                                                                        variant="link"
                                                                                        size="md"
                                                                                        className="d-flex align-items-center p-0 border-0 bg-transparent"
                                                                                        onClick={() => handleView(doc.id, doc.name || doc.filename)}
                                                                                    >
                                                                                        <span className="material-symbols-outlined me-1" style={{ fontSize: 20 }}>visibility</span>
                                                                                    </Button>
                                                                                    <Button
                                                                                        variant="link"
                                                                                        size="md"
                                                                                        className="d-flex align-items-center p-0 border-0 bg-transparent"
                                                                                        onClick={() => handleDownload(doc.id, doc.name || doc.filename)}
                                                                                    >
                                                                                        <span className="material-symbols-outlined me-1" style={{ fontSize: 20 }}>download</span>
                                                                                    </Button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        )}
                                        {errorShared && <div className="alert alert-danger mt-3">{errorShared}</div>}
                                    </Tab>
                                </Tabs>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <PdfViewerModal show={showPdfModal} onHide={() => setShowPdfModal(false)} pdfUrl={pdfUrl} docName={pdfName} />
            <DocxViewerModal show={showDocxModal} onHide={() => { setShowDocxModal(false); if (docxUrl) { window.URL.revokeObjectURL(docxUrl); setDocxUrl(null); } }} docxUrl={docxUrl} docName={docxName} />
            <ExcelViewerModal show={showExcelModal} onHide={() => { setShowExcelModal(false); if (excelUrl) { window.URL.revokeObjectURL(excelUrl); setExcelUrl(null); } }} excelUrl={excelUrl} docName={excelName} />
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar exclusão</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Tem certeza que deseja excluir o documento <strong>{documents.find(d => d.id === docToDelete)?.name || 'Selecionado'}</strong>?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancelar</Button>
                    <Button style={{ backgroundColor: '#dc3545', borderColor: '#dc3545', minWidth: 100, position: 'relative' }} className='d-flex align-items-center justify-content-center' onClick={() => handleDelete(docToDelete)} disabled={deleteLoading}>
                        {deleteLoading
                            ? <><span style={{position:'absolute', left:'50%', top:'50%', transform:'translate(-50%,-50%)'}}><Spinner animation="border" size="sm" /></span><span style={{visibility:'hidden'}}><span className="material-symbols-outlined me-1" style={{ fontSize: 20 }}>delete</span>Excluir</span></>
                            : <><span className="material-symbols-outlined me-1" style={{ fontSize: 20 }}>delete</span>Excluir</>}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showShareModal} onHide={() => setShowShareModal(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Compartilhar documento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingShare ? <div className="d-flex justify-content-center w-100 py-4">
                        <Spinner animation="border" />
                    </div> : (
                        <>
                            {errorShare && <Alert variant="danger">{errorShare}</Alert>}
                            <Row>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <Form.Label><strong>Amigos</strong></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Pesquisar amigos..."
                                            value={searchFriend}
                                            onChange={(e) => setSearchFriend(e.target.value)}
                                            className="mb-2"
                                        />
                                        <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #303030', borderRadius: '4px', padding: '6px' }}>
                                            {friends
                                                .filter(friend => friend.name.toLowerCase().includes(searchFriend.toLowerCase()))
                                                .map(friend => {
                                                    const isSelected = selectedFriends.includes(friend.id);
                                                    return (
                                                        <div
                                                            key={friend.id}
                                                            className={`mb-1 d-flex align-items-center selectable-item ${isSelected ? 'selected' : ''}`}
                                                            style={{
                                                                cursor: 'pointer',
                                                                borderRadius: '6px',
                                                                background: isSelected ? '#3A3A3A8A' : 'transparent',
                                                                border: isSelected ? '1px solid #5A5A5AFF' : '2px solid transparent',
                                                                padding: '6px 6px'
                                                            }}
                                                            onClick={() => {
                                                                setSelectedFriends(isSelected
                                                                    ? selectedFriends.filter(id => id !== friend.id)
                                                                    : [...selectedFriends, friend.id]);
                                                            }}
                                                        >
                                                            <div className="me-2" style={{ width: '25px', height: '25px', borderRadius: '50%', overflow: 'hidden', backgroundColor: '#f0f0f0' }}>
                                                                <img
                                                                    className="profile-img"
                                                                    src={
                                                                        imageErrors[`friend-${friend.id}`]
                                                                            ? '/assets/images/user/default-avatar.png'
                                                                            : (friend.user_about?.image_profile || friend.image_profile || '/assets/images/user/default-avatar.png')
                                                                    }
                                                                    alt={friend.name}
                                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                    onError={() => {
                                                                        setImageErrors(prev => ({
                                                                            ...prev,
                                                                            [`friend-${friend.id}`]: true
                                                                        }));
                                                                    }}
                                                                />
                                                            </div>
                                                            <span style={{ fontWeight: isSelected ? 'bold' : 'normal', color: isSelected ? '#ffffff' : '#cccccc' }}>
                                                                {friend.name.length > 12 ? friend.name.slice(0, 12) + '...' : friend.name}
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            {friends.filter(friend =>
                                                friend.name.toLowerCase().includes(searchFriend.toLowerCase())
                                            ).length === 0 && (
                                                    <div className="text-center text-muted">Nenhum amigo encontrado</div>
                                                )}
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <Form.Label><strong>Grupos</strong></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Pesquisar grupos..."
                                            value={searchGroup}
                                            onChange={(e) => setSearchGroup(e.target.value)}
                                            className="mb-2"
                                        />
                                        <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #303030', borderRadius: '4px', padding: '6px' }}>
                                            {groups
                                                .filter(group => group.id !== undefined && group.id !== null)
                                                .filter(group => group.name.toLowerCase().includes(searchGroup.toLowerCase()))
                                                .map(group => {
                                                    const isSelected = selectedGroups.includes(group.id);
                                                    return (
                                                        <div
                                                            key={group.id}
                                                            className={`mb-2 d-flex align-items-center selectable-item ${isSelected ? 'selected' : ''}`}
                                                            style={{
                                                                cursor: 'pointer',
                                                                borderRadius: '6px',
                                                                background: isSelected ? '#3A3A3A8A' : 'transparent',
                                                                border: isSelected ? '1px solid #5A5A5AFF' : '2px solid transparent',
                                                                padding: '6px 6px'
                                                            }}
                                                            onClick={() => {
                                                                setSelectedGroups(isSelected
                                                                    ? selectedGroups.filter(id => id !== group.id)
                                                                    : [...selectedGroups, group.id]);
                                                            }}
                                                        >
                                                            <div className="me-2" style={{ width: '25px', height: '25px', borderRadius: '50%', overflow: 'hidden', backgroundColor: '#f0f0f0' }}>
                                                                <img
                                                                    className="profile-img"
                                                                    src={
                                                                        imageErrors[`group-${group.id}`]
                                                                            ? userGenericImage
                                                                            : (group.photo && group.photo !== '' ? group.photo : userGenericImage)
                                                                    }
                                                                    alt={group.name}
                                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                    onError={() => {
                                                                        setImageErrors(prev => ({
                                                                            ...prev,
                                                                            [`group-${group.id}`]: true
                                                                        }));
                                                                    }}
                                                                />
                                                            </div>
                                                            <span style={{ fontWeight: isSelected ? 'bold' : 'normal', color: isSelected ? '#ffffff' : '#cccccc' }}>
                                                                {group.name.length > 12 ? group.name.slice(0, 12) + '...' : group.name}
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            {groups.filter(group =>
                                                group.id !== undefined &&
                                                group.id !== null &&
                                                group.name.toLowerCase().includes(searchGroup.toLowerCase())
                                            ).length === 0 && (
                                                    <div className="text-center text-muted">Nenhum grupo encontrado</div>
                                                )}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                        setShowShareModal(false);
                        setSearchFriend('');
                        setSearchGroup('');
                    }}>Cancelar</Button>
                    <Button variant="primary" onClick={handleShare} disabled={loadingShare || (!selectedFriends.length && !selectedGroups.length)}>
                        Compartilhar
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showRemoveShareModal} onHide={() => setShowRemoveShareModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar remoção</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Tem certeza que deseja remover o compartilhamento com <strong>{removeShareTargetName}</strong>?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowRemoveShareModal(false)}>Cancelar</Button>
                    <Button style={{ backgroundColor: '#dc3545', borderColor: '#dc3545' }} className='d-flex align-items-center' onClick={confirmRemoveShare}>
                        <span className="material-symbols-outlined me-1" style={{ fontSize: 20 }}>delete</span>
                        Remover
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showRemoveAllShareModal} onHide={() => setShowRemoveAllShareModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Remover todos os compartilhamentos</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Tem certeza que deseja remover <strong>todos</strong> os compartilhamentos do documento <strong>{removeAllShareDocName}</strong>?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowRemoveAllShareModal(false)}>Cancelar</Button>
                    <Button style={{ backgroundColor: '#dc3545', borderColor: '#dc3545' }} className='d-flex align-items-center' onClick={handleRemoveAllShares}>
                        <span className="material-symbols-outlined me-1" style={{ fontSize: 20 }}>delete</span>
                        Remover todos
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showImageModal} onHide={() => setShowImageModal(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{imageName}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center p-0">
                    {imageUrl && (
                        <img
                            src={imageUrl}
                            alt={imageName}
                            style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                        />
                    )}
                </Modal.Body>
            </Modal>
            <Modal show={showVideoModal} onHide={() => setShowVideoModal(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{videoName}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center p-0">
                    {videoUrl && (
                        <video
                            controls
                            style={{ maxWidth: '100%', maxHeight: '80vh' }}
                        >
                            <source src={videoUrl} type="video/mp4" />
                            Seu navegador não suporta o elemento de vídeo.
                        </video>
                    )}
                </Modal.Body>
            </Modal>
            <Modal show={showNoPreviewModal} onHide={() => setShowNoPreviewModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Visualização não disponível</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <div className="mb-3">
                        <span className="material-symbols-outlined" style={{ fontSize: '48px', color: '#dc3545' }}>
                            error_outline
                        </span>
                    </div>
                    <p className="mb-0">A visualização do arquivo <strong>{noPreviewFileName}</strong> não está disponível.</p>
                    <p className="text-muted">Você pode fazer o download do arquivo para visualizá-lo.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowNoPreviewModal(false)}>
                        Fechar
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => {
                            handleDownload(noPreviewDocId, noPreviewFileName);
                            setShowNoPreviewModal(false);
                        }}
                    >
                        <span className="material-symbols-outlined me-1" style={{ fontSize: 20 }}>download</span>
                        Fazer download
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showEditShareModal} onHide={() => setShowEditShareModal(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Editar compartilhamentos</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editShareLoading ? <div className="d-flex justify-content-center w-100 py-4">
                        <Spinner animation="border" />
                    </div> : (
                        <>
                            {editShareError && <Alert variant="danger">{editShareError}</Alert>}
                            <Row>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <Form.Label><strong>Usuários já compartilhados</strong></Form.Label>
                                        <div style={{ height: '20vh', overflowY: 'auto', border: '1px solid #303030', borderRadius: '4px', padding: '6px', marginBottom: 10 }}>
                                            {editSharedUsers.length === 0 && <div className="text-muted">Nenhum usuário</div>}
                                            {editSharedUsers.filter(user => editSelectedFriends.includes(user.id)).map(user => (
                                                <div key={user.id} className="d-flex align-items-center justify-content-between mb-1" style={{ background: '#232323', borderRadius: 6, padding: '4px 8px' }}>
                                                    <span className="d-flex align-items-center">
                                                        <img src={user.user_about?.image_profile || '/assets/images/user/default-avatar.png'} alt={user.name} style={{ width: 22, height: 22, borderRadius: '50%', objectFit: 'cover', marginRight: 8 }} />
                                                        {user.name.length > 16 ? user.name.slice(0, 16) + '...' : user.name}
                                                    </span>
                                                    <Button variant="link" size="sm" style={{ color: '#dc3545' }} onClick={() => handleRemoveSharedUser(user.id)}>
                                                        <span className="material-symbols-outlined" style={{ fontSize: 18 }}>close</span>
                                                    </Button>
                                                </div>
                                            ))}
                                        </div>
                                        <Form.Label><strong>Adicionar amigos</strong></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Pesquisar amigos..."
                                            value={editSearchFriend}
                                            onChange={(e) => setEditSearchFriend(e.target.value)}
                                            className="mb-2"
                                        />
                                        <div style={{ height: '20vh', overflowY: 'auto', border: '1px solid #303030', borderRadius: '4px', padding: '6px' }}>
                                            {editShareableUsers
                                                .filter(friend => friend.name && friend.name.toLowerCase().includes(editSearchFriend.toLowerCase()))
                                                .map(friend => {
                                                    const isSelected = editSelectedFriends.includes(friend.id);
                                                    return (
                                                        <div
                                                            key={friend.id}
                                                            className={`mb-1 d-flex align-items-center selectable-item ${isSelected ? 'selected' : ''}`}
                                                            style={{
                                                                cursor: 'pointer',
                                                                borderRadius: '6px',
                                                                background: isSelected ? '#3A3A3A8A' : 'transparent',
                                                                border: isSelected ? '1px solid #5A5A5AFF' : '2px solid transparent',
                                                                padding: '6px 6px'
                                                            }}
                                                            onClick={() => {
                                                                if (isSelected) {
                                                                    setEditSelectedFriends(editSelectedFriends.filter(id => id !== friend.id));
                                                                } else {
                                                                    setEditSelectedFriends([...editSelectedFriends, friend.id]);
                                                                }
                                                            }}
                                                        >
                                                            <div className="me-2" style={{ width: '22px', height: '22px', borderRadius: '50%', overflow: 'hidden', backgroundColor: '#f0f0f0' }}>
                                                                <img
                                                                    className="profile-img"
                                                                    src={
                                                                        imageErrors[`friend-${friend.id}`]
                                                                            ? '/assets/images/user/default-avatar.png'
                                                                            : (friend.user_about?.image_profile || friend.image_profile || '/assets/images/user/default-avatar.png')
                                                                    }
                                                                    alt={friend.name}
                                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                    onError={() => {
                                                                        setImageErrors(prev => ({
                                                                            ...prev,
                                                                            [`friend-${friend.id}`]: true
                                                                        }));
                                                                    }}
                                                                />
                                                            </div>
                                                            <span style={{ fontWeight: isSelected ? 'bold' : 'normal', color: isSelected ? '#ffffff' : '#cccccc' }}>
                                                                {friend.name.length > 12 ? friend.name.slice(0, 12) + '...' : friend.name}
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            {editShareableUsers.filter(friend => friend.name && friend.name.toLowerCase().includes(editSearchFriend.toLowerCase())).length === 0 && (
                                                <div className="text-center text-muted">Nenhum amigo encontrado</div>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <Form.Label><strong>Grupos já compartilhados</strong></Form.Label>
                                        <div style={{ height: '20vh', overflowY: 'auto', border: '1px solid #303030', borderRadius: '8px', padding: '6px', marginBottom: 10 }}>
                                            {editSharedGroups.length === 0 && <div className="text-muted">Nenhum grupo</div>}
                                            {editSharedGroups.filter(group => editSelectedGroups.includes(group.id)).map(group => (
                                                <div key={group.id} className="d-flex align-items-center justify-content-between mb-1" style={{ background: '#232323', borderRadius: 6, padding: '4px 8px' }}>
                                                    <span className="d-flex align-items-center">
                                                        <img src={group.photo || userGenericImage} alt={group.name} style={{ width: 22, height: 22, borderRadius: '50%', objectFit: 'cover', marginRight: 8 }} />
                                                        {group.name.length > 16 ? group.name.slice(0, 16) + '...' : group.name}
                                                    </span>
                                                    <Button variant="link" size="sm" style={{ color: '#dc3545' }} onClick={() => handleRemoveSharedGroup(group.id)}>
                                                        <span className="material-symbols-outlined" style={{ fontSize: 18 }}>close</span>
                                                    </Button>
                                                </div>
                                            ))}
                                        </div>
                                        <Form.Label><strong>Adicionar grupos</strong></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Pesquisar grupos..."
                                            value={editSearchGroup}
                                            onChange={(e) => setEditSearchGroup(e.target.value)}
                                            className="mb-2"
                                        />
                                        <div style={{ height: '20vh', overflowY: 'auto', border: '1px solid #303030', borderRadius: '8px', padding: '6px' }}>
                                            {editShareableGroups
                                                .filter(group => group.name && group.name.toLowerCase().includes(editSearchGroup.toLowerCase()))
                                                .map(group => {
                                                    const isSelected = editSelectedGroups.includes(group.id);
                                                    return (
                                                        <div
                                                            key={group.id}
                                                            className={`mb-2 d-flex align-items-center selectable-item ${isSelected ? 'selected' : ''}`}
                                                            style={{
                                                                cursor: 'pointer',
                                                                borderRadius: '6px',
                                                                background: isSelected ? '#3A3A3A8A' : 'transparent',
                                                                border: isSelected ? '1px solid #5A5A5AFF' : '2px solid transparent',
                                                                padding: '6px 6px'
                                                            }}
                                                            onClick={() => {
                                                                if (isSelected) {
                                                                    setEditSelectedGroups(editSelectedGroups.filter(id => id !== group.id));
                                                                } else {
                                                                    setEditSelectedGroups([...editSelectedGroups, group.id]);
                                                                }
                                                            }}
                                                        >
                                                            <div className="me-2" style={{ width: '22px', height: '22px', borderRadius: '50%', overflow: 'hidden', backgroundColor: '#f0f0f0' }}>
                                                                <img
                                                                    className="profile-img"
                                                                    src={
                                                                        imageErrors[`group-${group.id}`]
                                                                            ? userGenericImage
                                                                            : (group.photo && group.photo !== '' ? group.photo : userGenericImage)
                                                                    }
                                                                    alt={group.name}
                                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                    onError={() => {
                                                                        setImageErrors(prev => ({
                                                                            ...prev,
                                                                            [`group-${group.id}`]: true
                                                                        }));
                                                                    }}
                                                                />
                                                            </div>
                                                            <span style={{ fontWeight: isSelected ? 'bold' : 'normal', color: isSelected ? '#ffffff' : '#cccccc' }}>
                                                                {group.name.length > 12 ? group.name.slice(0, 12) + '...' : group.name}
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            {editShareableGroups.filter(group => group.name && group.name.toLowerCase().includes(editSearchGroup.toLowerCase())).length === 0 && (
                                                <div className="text-center text-muted">Nenhum grupo encontrado</div>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditShareModal(false)}>Cancelar</Button>
                    <Button variant="primary" onClick={handleEditShare} disabled={editShareLoading}>
                        {editShareLoading ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Salvando...
                            </>
                        ) : 'Salvar alterações'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Index; 